/**
 * CloudFront presigned file URLs include an `Expires` query param (Unix seconds).
 */
export function getPresignedUrlExpiresAtMs(
  url: string | undefined,
): number | null {
  if (!url) return null;
  try {
    const expires = new URL(url).searchParams.get("Expires");
    if (!expires) return null;
    const seconds = Number.parseInt(expires, 10);
    if (!Number.isFinite(seconds) || seconds <= 0) return null;
    return seconds * 1000;
  } catch {
    return null;
  }
}

/** Milliseconds until we should refresh, with a lead time before actual expiry. */
export function getPresignedUrlRefreshDelayMs(
  expiresAtMs: number,
  nowMs: number = Date.now(),
): number {
  const ttlMs = expiresAtMs - nowMs;
  if (ttlMs <= 0) return 0;
  const leadMs = Math.min(60_000, Math.max(5_000, ttlMs * 0.1));
  return Math.max(0, ttlMs - leadMs);
}
